import React, { useState, useEffect } from 'react'
import Transparent from './images/transparent.gif'
import Loading from './images/loading40.gif'
import axios from 'axios';
import Cookies from 'universal-cookie';
import Soccerpng from './images/12bet/soccer.png'
import cricketpng from "./images/12bet/cricketBall.png"
import Tennispng from "./images/12bet/tennispng.png"
import "./Risk.css"
import moment from 'moment'
import { toast } from 'react-toastify'
import MarketView from './MarketView'
import CricketMatchSock from './CricketMatchSock';
import SoccerMatchSock from './SoccerMatchSock';
import TennisMatchSock from './TennisMatchSock';
import DeclaredFancy from './DeclaredFancy'
import FancyBook from "./FancyBook";

toast.configure()


require('moment-timezone');

const cookies = new Cookies();

export default function RiskManagement(props) {

    const [marketClick, setmarketClick] = useState(-1)
    const [marketClick1, setmarketClick1] = useState(-1)
    const [marketClick2, setmarketClick2] = useState(-1)
    const [select, setselect] = useState(0)
    const [marketData, setmarketData] = useState({})
    const [bookData2, setbookData2] = useState({})
    const [bookData, setbookData] = useState({})
    const [cricketList, setcricketList] = useState([]);
    const [showDownline, setshowDownline] = useState(false);
    const [soccerList, setsoccerList] = useState([]);
    const [tennisList, settennisList] = useState([]);
    const [refresh, setrefresh] = useState(true);
    const [reload, setreload] = useState(true);
    const [eventIdset, seteventIdset] = useState('')
    const [eventId, seteventId] = useState('')
    const [runner1BackRate3, setrunner1BackRate3] = useState(' ');
    const [runner1BackSize1, setrunner1BackSize1] = useState(' ');
    const [runner1BackSize2, setrunner1BackSize2] = useState(' ');
    const [runner1BackSize3, setrunner1BackSize3] = useState(' ');
    const [runner1LayRate1, setrunner1LayRate1] = useState(' ');
    const [runner1LayRate2, setrunner1LayRate2] = useState(' ');
    const [runner1LayRate3, setrunner1LayRate3] = useState(' ');
    const [runner1LaySize1, setrunner1LaySize1] = useState(' ');
    const [runner1LaySize2, setrunner1LaySize2] = useState(' ');
    const [runner1LaySize3, setrunner1LaySize3] = useState(' ');
    const [runner1BackRate1, setrunner1BackRate1] = useState(' ');
    const [runner1BackRate2, setrunner1BackRate2] = useState(' ');
    const [runner2BackRate1, setrunner2BackRate1] = useState(' ');
    const [runner2BackRate2, setrunner2BackRate2] = useState(' ');
    const [runner2BackRate3, setrunner2BackRate3] = useState(' ');
    const [runner2BackSize1, setrunner2BackSize1] = useState(' ');
    const [runner2BackSize2, setrunner2BackSize2] = useState(' ');
    const [runner2BackSize3, setrunner2BackSize3] = useState(' ');
    const [runner2LayRate1, setrunner2LayRate1] = useState(' ');
    const [runner2LayRate2, setrunner2LayRate2] = useState(' ');
    const [runner2LayRate3, setrunner2LayRate3] = useState(' ');
    const [runner2LaySize1, setrunner2LaySize1] = useState(' ');
    const [runner2LaySize2, setrunner2LaySize2] = useState(' ');
    const [runner2LaySize3, setrunner2LaySize3] = useState(' ');


    const [tieBackRate1, settieBackRate1] = useState(' ');
    const [tieBackRate2, settieBackRate2] = useState(' ');
    const [tieBackRate3, settieBackRate3] = useState(' ');
    const [tieBackSize1, settieBackSize1] = useState(' ');
    const [tieBackSize2, settieBackSize2] = useState(' ');
    const [tieBackSize3, settieBackSize3] = useState(' ');
    const [tieLayRate1, settieLayRate1] = useState(' ');
    const [tieLayRate2, settieLayRate2] = useState(' ');
    const [tieLayRate3, settieLayRate3] = useState(' ');
    const [tieLaySize1, settieLaySize1] = useState(' ');
    const [tieLaySize2, settieLaySize2] = useState(' ');
    const [tieLaySize3, settieLaySize3] = useState(' ');
    const [fancyData, setfancyData] = useState([])
    const [marketBetStatus, setmarketBetStatus] = useState(0);
    const [popup, setpopup] = useState(null);
    const [marketpnl1, setmarketpnl1] = useState(0);
    const [marketpnl2, setmarketpnl2] = useState(0);
    const [marketpnl3, setmarketpnl3] = useState(0);
    const [bookpnl1, setbookpnl1] = useState(0);
    const [bookpnl2, setbookpnl2] = useState(0);
    const [bookpnl3, setbookpnl3] = useState(0);
    const [fancySelection, setfancySelection] = useState(null);
    const [fancyName, setfancyName] = useState('');
    const [marketIdnew, setmarketIdnew] = useState('')
    const [marketName, setmarketName] = useState('')


    const MarketClickOpen = (index) => {
        setmarketClick(!marketClick)

        if (marketClick === index) {
            setmarketClick(-1);
        }
        else {
            setmarketClick(index);
        }
    }



    const MarketClickOpen1 = (index) => {
        setmarketClick1(!marketClick1)

        if (marketClick1 === index) {
            setmarketClick1(-1);
        }
        else {
            setmarketClick1(index);
        }
    }

    const MarketClickOpen2 = (index) => {
        setmarketClick2(!marketClick2)

        if (marketClick2 === index) {
            setmarketClick2(-1);
        }
        else {
            setmarketClick2(index);
        }
    }


    useEffect(() => {
        getProfitLoss();

        const intervalId = setInterval(() => {
            getProfitLoss();
        }, 5000);


        return () => clearInterval(intervalId);

    }, [marketData, bookData2, props.eventId])



    useEffect(() => {


        if (!props.eventId) return;

        axios.post('https://flagapi.in/clientapi/getFullMarket', {

            eventId: props.eventId,

        })
            .then(result => {
                // console.log(result);

                if (result.data[0]) {
                    let obj = result.data[0];
                    setrunner1BackRate1(obj.runner1BackRate1);
                    setrunner1BackRate2(obj.runner1BackRate2);
                    setrunner1BackRate3(obj.runner1BackRate3);
                    setrunner1LayRate1(obj.runner1LayRate1);
                    setrunner1LayRate2(obj.runner1LayRate2);
                    setrunner1LayRate3(obj.runner1LayRate3);
                    setrunner2BackRate1(obj.runner2BackRate1);
                    setrunner2BackRate2(obj.runner2BackRate2);
                    setrunner2BackRate3(obj.runner2BackRate3);
                    setrunner2LayRate1(obj.runner2LayRate1);
                    setrunner2LayRate2(obj.runner2LayRate2);
                    setrunner2LayRate3(obj.runner2LayRate3);

                    if (obj.runnerId3) {
                        settieBackRate1(obj.tieBackRate1);
                        settieBackRate2(obj.tieBackRate2);
                        settieBackRate3(obj.tieBackRate3);
                        settieLayRate1(obj.tieLayRate1);
                        settieLayRate2(obj.tieLayRate2);
                        settieLayRate3(obj.tieLayRate3);

                    }
                    //   console.log(obj);

                    setmarketData(obj);
                }

            })
            .catch(e => {

            });


        axios.post('https://flagapi.in.com/api/client/clientgetBookMakerMarket', {

            eventId: props.eventId,

        })
            .then(result => {


                if (result.data[0]) {
                    let obj = result.data[0];
                    setbookData2(obj);
                }



            })
            .catch(e => {

            });
    }, []);



    const getProfitLoss = () => {
        var ssid = cookies.get('sid');

        if (!ssid) return;
        if (!props.eventId) return;

        if (marketData.marketId) {
            axios.post('https://flagapi.in/agentapi/newagentMarketExposure', {
                sid: ssid,
                eventId: props.eventId,
                marketId: marketData.marketId

            })
                .then(result => {

                    if (refresh) { setrefresh(false); }
                    if (result.status === 200) {

                        setmarketpnl1(result.data.teamA_total);
                        setmarketpnl2(result.data.teamB_total);
                        setmarketpnl3(result.data.draw_total);
                        // console.log(result.data);

                    }

                })
                .catch(e => {

                });
        }

        if (bookData2.marketId) {

            axios.post('https://flagapi.in/agentapi/newagentMarketExposure', {
                sid: ssid,
                eventId: props.eventId,
                marketId: bookData2.marketId

            })
                .then(result => {

                    if (refresh) { setrefresh(false); }
                    if (result.status === 200) {

                        setbookpnl1(result.data.teamA_total);
                        setbookpnl2(result.data.teamB_total);
                        setbookpnl3(result.data.draw_total);


                    }

                })
                .catch(e => {

                });

        }

    }



    // end runningmarketana
    useEffect(() => {

        var ssid = cookies.get('sid');
        if (!ssid) return;
        setrefresh(true);

        axios.post('https://flagapi.in/agentapi/riskManagementList', {
            sid: ssid,
            eventType: 4
        })
            .then(result => {
                setrefresh(false);
                var res = [];
                if (result.status === 200) {
                    for (let key in result.data) {

                        if (result.data.hasOwnProperty(key)) {
                            result.data[key].eventId = key;
                            res.push(result.data[key]);


                        }
                    }
                    setcricketList(res);

                }



            }

            ).catch(e => {
                //setIsError(true);
            });

        axios.post('https://flagapi.in/agentapi/riskManagementList', {
            sid: ssid,
            eventType: 1
        })
            .then(result => {

                if (result.status === 200) {
                    var res = [];

                    for (let key in result.data) {

                        if (result.data.hasOwnProperty(key)) {
                            result.data[key].eventId = key;
                            res.push(result.data[key]);

                        }
                    }
                    setsoccerList(res);

                }

            }

            ).catch(e => {
                //setIsError(true);
            });

        axios.post('https://flagapi.in/agentapi/riskManagementList', {
            sid: ssid,
            eventType: 2
        })
            .then(result => {

                if (result.status === 200) {
                    var res = [];

                    for (let key in result.data) {

                        if (result.data.hasOwnProperty(key)) {
                            result.data[key].eventId = key;
                            res.push(result.data[key]);

                        }
                    }
                    settennisList(res);

                }



            }

            ).catch(e => {
                //setIsError(true);
            });
    }, [reload])




    const changeDownlineLive = () => {
        setshowDownline(false);
        setpopup(null);
        setfancySelection(null);
        setfancyName('');

    }


    // const ViewClick = () => {
    //     window.open("/agent/riskManagement/riskDownLinePL", "", "width=1250, height=610")
    // }


    return (

        <React.Fragment>
            <div class="main_wrap">

                {refresh && <div id="loading" class="loading-wrap" style={{}}>
                    <ul class="loading">
                        <li>
                            <img src={Loading} />
                        </li>
                        <li>Loading...</li>
                    </ul>
                </div>}


                {/* <!-- Message --> */}
                <div id="message" class="message-wrap success">

                    <a class="btn-close">Close</a>
                    <p></p>
                </div>

                {/* <!-- Report Table --> */}
                <div class="total_all">
                    <h2>Bet Management 
                    </h2>

                    <a class="btn_replay" id="refresh_Top_Racing" style={{ display: 'none' }}>
                        <img src={Transparent} /></a>
                </div>

                <div className="play_race-wrap">
                    <div className="top_player-wrap">
                        <h3>
                            <ul className="tab-topplay">
                                <li id="top10MatchedAmountLi" className={`${(select === 0) ? "select" : "null"}`} >
                                    <a onClick={() => { setselect(0) }}>Top 10 Matched Amount Player</a></li>
                                <li id="top10ExposureLi" className={`${(select === 1) ? "select" : "null"}`}>
                                    <a onClick={() => { setselect(1) }}>Top 10 Exposure Player</a></li>
                            </ul>
                        </h3>
                        {select === 0 && <div className="col-2">
                            <ul className="slip-head">
                                <li className="col-playID">UID</li>
                                <li className="col-exp">Exposure</li>
                                <li className="col-amount sort-this">Matched Amount</li>
                            </ul>
                            <table className="table01">
                                <tbody id="content_top_1_5">
                                    <tr id="tempTr_top">
                                        <td className="align-L">
                                            <span className="order" id="number">1.</span>

                                            <a id="userId"></a>
                                        </td>
                                        <td id="exposure"><span className="red"></span></td>
                                        <td id="amount"></td>
                                    </tr>
                                    <tr id="tempTr_top">
                                        <td className="align-L">
                                            <span className="order" id="number">2.</span>

                                            <a id="userId"></a>
                                        </td>
                                        <td id="exposure"><span className="red"></span></td>
                                        <td id="amount"></td>
                                    </tr>
                                    <tr id="tempTr_top">
                                        <td className="align-L">
                                            <span className="order" id="number">3.</span>

                                            <a id="userId"></a>
                                        </td>
                                        <td id="exposure"></td>
                                        <td id="amount"></td>
                                    </tr>
                                    <tr id="tempTr_top">
                                        <td className="align-L">
                                            <span className="order" id="number">4.</span>

                                            <a id="userId"></a>
                                        </td>
                                        <td id="exposure"><span className="red"></span></td>
                                        <td id="amount"></td>
                                    </tr>
                                    <tr id="tempTr_top">
                                        <td className="align-L">
                                            <span className="order" id="number">5.</span>

                                            <a id="userId"></a>
                                        </td>
                                        <td id="exposure"><span className="red"></span></td>
                                        <td id="amount"></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        }
                        {select === 0 && <div className="col-2">
                            <ul className="slip-head">
                                <li className="col-playID">UID</li>
                                <li className="col-exp">Exposure</li>
                                <li className="col-amount sort-this">Matched Amount</li>
                            </ul>
                            <table className="table01">
                                <tbody id="content_top_6_10">
                                    <tr id="tempTr_top">
                                        <td className="align-L">
                                            <span className="order" id="number">6.</span>

                                            <a id="userId"></a>
                                        </td>
                                        <td id="exposure"><span className="red"></span></td>
                                        <td id="amount"></td>
                                    </tr>
                                    <tr id="tempTr_top">
                                        <td className="align-L">
                                            <span className="order" id="number">7.</span>

                                            <a id="userId"></a>
                                        </td>
                                        <td id="exposure"><span className="red"></span></td>
                                        <td id="amount"></td>
                                    </tr>
                                    <tr id="tempTr_top">
                                        <td className="align-L">
                                            <span className="order" id="number">8.</span>

                                            <a id="userId"></a>
                                        </td>
                                        <td id="exposure"><span className="red"></span></td>
                                        <td id="amount"></td>
                                    </tr>
                                    <tr id="tempTr_top">
                                        <td className="align-L">
                                            <span className="order" id="number">9.</span>

                                            <a id="userId"></a>
                                        </td>
                                        <td id="exposure"><span className="red"></span></td>
                                        <td id="amount"></td>
                                    </tr>
                                    <tr id="tempTr_top">
                                        <td className="align-L">
                                            <span className="order" id="number">10.</span>

                                            <a id="userId"></a>
                                        </td>
                                        <td id="exposure"><span className="red"></span></td>
                                        <td id="amount"></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        }
                        {select === 1 && <div className="col-2">
                            <ul className="slip-head">
                                <li className="col-playID">UID</li>
                                <li className="col-exp sort-this">Exposure</li>
                                <li className="col-amount">Matched Amount</li>
                            </ul>
                            <table className="table01">
                                <tbody id="content_top_1_5">
                                    <tr id="tempTr_top">
                                        <td className="align-L">
                                            <span className="order" id="number">1.</span>
                                            <a id="userId"></a>
                                        </td>
                                        <td id="exposure"><span className="red"></span></td>
                                        <td id="amount"></td>
                                    </tr>
                                    <tr id="tempTr_top">
                                        <td className="align-L">
                                            <span className="order" id="number">2.</span>
                                            <a id="userId"></a>
                                        </td>
                                        <td id="exposure"><span className="red"></span></td>
                                        <td id="amount"></td>
                                    </tr>
                                    <tr id="tempTr_top">
                                        <td className="align-L">
                                            <span className="order" id="number">3.</span>
                                            <a id="userId"></a>
                                        </td>
                                        <td id="exposure"><span className="red"></span></td>
                                        <td id="amount"></td>
                                    </tr>
                                    <tr id="tempTr_top">
                                        <td className="align-L">
                                            <span className="order" id="number">4.</span>
                                            <a id="userId"></a>
                                        </td>
                                        <td id="exposure"><span className="red"></span></td>
                                        <td id="amount"></td>
                                    </tr>
                                    <tr id="tempTr_top">
                                        <td className="align-L">
                                            <span className="order" id="number">5.</span>
                                            <a id="userId"></a>
                                        </td>
                                        <td id="exposure">
                                            <span className="red"></span></td>
                                        <td id="amount"></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        }

                        {select === 1 && <div className="col-2">
                            <ul className="slip-head">
                                <li className="col-playID">UID</li>
                                <li className="col-exp sort-this">Exposure</li>
                                <li className="col-amount">Matched Amount</li>
                            </ul>
                            <table className="table01">
                                <tbody id="content_top_1_5">
                                    <tr id="tempTr_top">
                                        <td className="align-L">
                                            <span className="order" id="number">1.</span>

                                        </td>
                                        <td id="exposure"></td>
                                        <td id="amount"></td>
                                    </tr>
                                    <tr id="tempTr_top">
                                        <td className="align-L">
                                            <span className="order" id="number">2.</span>

                                        </td>
                                        <td id="exposure"></td>
                                        <td id="amount"></td>
                                    </tr>
                                    <tr id="tempTr_top">
                                        <td className="align-L">
                                            <span className="order" id="number">3.</span>

                                        </td>
                                        <td id="exposure"></td>
                                        <td id="amount"></td>
                                    </tr>
                                    <tr id="tempTr_top">
                                        <td className="align-L">
                                            <span className="order" id="number">4.</span>

                                        </td>
                                        <td id="exposure"></td>
                                        <td id="amount"></td>
                                    </tr>
                                    <tr id="tempTr_top">
                                        <td className="align-L">
                                            <span className="order" id="number">5.</span>

                                        </td>
                                        <td id="exposure">
                                        </td>
                                        <td id="amount"></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        }
                    </div>
                    {/* <div className="racing-wrap">
                        <h3>Horse Racing &amp; Greyhound Racing
                        </h3>
                        <ul className="slip-head">
                            <li className="col-type">Type</li>
                            <li className="col-country">Country</li>
                            <li className="col-local">Events</li>
                            <li className="col-amount">Matched Amount</li>
                        </ul>
                        <div className="over-wrap" style={{ height: '160px' }}>
                            <table style={{ display: 'none' }}>
                                <tbody>
                                    <tr id="tempTr_racing">
                                        <td width={30} className="td-type"><span id="eventType" /></td>
                                        <td width={60} className="align-L">
                                            <a id="country" href="javascript:void (0);" /></td>
                                        <td className="align-L">
                                            <a href="javascript:void (0);" id="eventName" /></td>
                                        <td width={100} id="amount" />
                                    </tr>
                                    <tr id="tempTr_noData_racing">
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                    </tr>
                                </tbody>
                            </table>
                            <table className="table01">
                                <tbody id="content_racing">
                                    <tr id="tempTr_noData_racing">
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                    </tr>
                                    <tr id="tempTr_noData_racing">
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                    </tr>
                                    <tr id="tempTr_noData_racing">
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                    </tr>
                                    <tr id="tempTr_noData_racing">
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                    </tr>
                                    <tr id="tempTr_noData_racing">
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div> */}
                </div>

                <div className="match-wrap1">
                    <div className="total_all">
                        <h2>Cricket </h2>
                        <h2><  img className="png-match" src={cricketpng} /></h2>

                        <a className="btn_replay" onClick={() => { setreload(!reload); }} id="refresh_Match_Odds"><img src={Transparent} /></a>

                        <a className="btn_replay" id="downloadFile_Sportsbook" style={{ display: 'none', width: '70px' }}>Download</a>
                    </div>
                    <table style={{ display: 'none' }}>
                        <tbody>
                            <tr id="tempTr_MATCH_ODDS_DRAW">
                                <td className="align-L" rowSpan={1} style={{}}>
                                    <a id="eventType" /></td>
                                <td className="align-L border-l" rowSpan={1} id="marketTime" style={{}} />
                                <td className="align-L border-l">

                                    <a className="btn open-odds" id="showOddsBtn" style={{}}>Open</a>

                                    <a id="marketPath">
                                        <strong id="eventName" />

                                        <img className="fromto" src={Transparent} />
                                        <span id="marketName" />
                                    </a>
                                </td>
                                <td className="border-l">
                                    <a className id="selection_exposure_1">-</a></td>
                                <td>
                                    <a className id="selection_exposure_3">-</a></td>
                                <td>
                                    <a className id="selection_exposure_2">-</a></td>
                                <td className="border-l">
                                    <a className="btn" id="view">View</a></td>
                            </tr>
                            <tr id="tempTr_MATCH_ODDS">
                                <td className="align-L" rowSpan={1} style={{}}>
                                    <a id="eventType" /></td>
                                <td className="align-L border-l" rowSpan={1} id="marketTime" style={{}} />
                                <td className="align-L border-l">

                                    <a className="btn open-odds" id="showOddsBtn" style={{}}>Open</a>

                                    <a id="marketPath">
                                        <strong id="eventName" />

                                        <img className="fromto" src={Transparent} />
                                        <span id="marketName" />
                                    </a>
                                </td>
                                <td className="border-l">
                                    <a className id="selection_exposure_1">-</a></td>
                                <td>
                                    <a className id="selection_exposure_2">-</a></td>
                                <td className="border-l">
                                    <a className="btn" id="view">View</a></td>
                            </tr>
                            <tr id="tempTr_expand_MATCH_ODDS_DRAW" className="expand" style={{ display: 'none' }}>
                                <td className="border-l align-L" colSpan={4}>

                                    {/* <img className="expand-arrow" src={Transparent} /> */}

                                    <div className="for-agent">
                                        <div className="head-bets-agent">
                                            <span className="game-low_liq" id="lowLiquidity" style={{ display: 'none' }}>Low Liquidity</span>
                                            <dl className="game-matched">
                                                <dt>Total Stakes</dt>
                                                <dd id="totalStake">USD323.00</dd>
                                            </dl>
                                            <dl className="game-matched">
                                                <dt>Matched</dt>
                                                <dd id="totalMatched">USD336,281,366</dd>
                                            </dl>
                                            <ul className="game-info">
                                                <li className="green" id="inPlay" style={{}}>
                                                    <img className="icon-irun" src={Transparent} />In-Play</li>
                                            </ul>
                                        </div>
                                        <div className="bets-wrap">
                                            <span className="refer_only">
                                                <span id="selectionCount">3</span> Selections</span>
                                            <table className="bets" id="marketOdds">
                                                <tbody>
                                                    <tr className="bet-all">
                                                        <td />
                                                        <td className="refer-bet" colSpan={2} id="backPercent">100.7%</td>
                                                        <td>

                                                            <a className="back-all">
                                                                <img src={Transparent} />
                                                                <span>Back all</span></a>
                                                        </td>
                                                        <td>

                                                            <a className="lay-all">
                                                                <img src={Transparent} />
                                                                <span>Lay all</span></a>
                                                        </td>
                                                        <td className="refer-book" colSpan={2} id="layPercent">99.8%</td>
                                                    </tr>
                                                </tbody>
                                                <tbody id="content">
                                                    <tr id="31135408_414464">
                                                        <th className id="selection">
                                                            <p>
                                                                <a id="marketDepth">
                                                                    <img className="icon-predict" src={Transparent} /></a>India</p>
                                                        </th>

                                                        <td className="back-3" id="back_3">
                                                            <a >1.69<span>889</span></a></td>
                                                        <td className="back-2" id="back_2">
                                                            <a >1.7<span>2,786</span></a></td>
                                                        <td className="back-1 spark" id="back_1">
                                                            <a >1.71<span>1,376</span></a></td>
                                                        <td className="lay-1 spark" id="lay_1">
                                                            <a >1.72<span>5,243</span></a></td>
                                                        <td className="lay-2 spark" id="lay_2">
                                                            <a >1.73<span>12,788</span></a></td>
                                                        <td className="lay-3 spark" id="lay_3">
                                                            <a >1.74<span>178,770</span></a></td>
                                                    </tr>
                                                    <tr id="31135408_60443">
                                                        <th className id="selection">
                                                            <p>
                                                                <a id="marketDepth">
                                                                    <img className="icon-predict" src={Transparent} />
                                                                </a>The Draw</p>
                                                        </th>

                                                        <td className="back-3" id="back_3">
                                                            <a >29<span>176</span></a></td>
                                                        <td className="back-2" id="back_2">
                                                            <a >30<span>14,619</span></a></td>
                                                        <td className="back-1" id="back_1">
                                                            <a >32<span>35</span></a></td>
                                                        <td className="lay-1" id="lay_1">
                                                            <a >34<span>644</span></a></td>
                                                        <td className="lay-2" id="lay_2">
                                                            <a >36<span>164</span></a></td>
                                                        <td className="lay-3" id="lay_3">
                                                            <a >38<span>152</span></a></td>
                                                    </tr>
                                                    <tr id="31135408_349">
                                                        <th className id="selection">
                                                            <p>
                                                                <a id="marketDepth">
                                                                    <img className="icon-predict" src={Transparent} />
                                                                </a>South Africa</p>
                                                        </th>

                                                        <td className="back-3 spark" id="back_3">
                                                            <a >2.52<span>128,174</span></a></td>
                                                        <td className="back-2 spark" id="back_2">
                                                            <a >2.54<span>6,664</span></a></td>
                                                        <td className="back-1 spark" id="back_1">
                                                            <a >2.56<span>121,020</span></a></td>
                                                        <td className="lay-1" id="lay_1">
                                                            <a >2.58<span>431</span></a></td>
                                                        <td className="lay-2" id="lay_2">
                                                            <a >2.6<span>1,527</span></a></td>
                                                        <td className="lay-3 spark" id="lay_3">
                                                            <a >2.62<span>588</span></a></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>

                                    <iframe src frameBorder={0} height={197} scrolling="no" />
                                </td>
                                <td width={80} className="border-l" />
                            </tr>
                            <tr id="tempTr_expand_MATCH_ODDS" className="expand" style={{ display: 'none' }}>
                                <td className="border-l align-L" colSpan={3}>

                                    {/* <img className="expand-arrow" src={Transparent} /> */}
                                    <iframe src frameBorder={0} height={197} scrolling="no" />

                                </td>
                                <td width={80} className="border-l" />
                            </tr>
                            <tr id="tempTr_noData_MATCH_ODDS_DRAW">
                                <td className="no-data" colSpan={7}>
                                    <p>No Data
                                    </p>
                                </td>
                            </tr>
                            <tr id="tempTr_noData_MATCH_ODDS">
                                <td className="no-data" colSpan={6}>
                                    <p>No Data
                                    </p>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <table className="table011 risk_matchodd">

                        <tbody>
                            <tr>
                                <th width="10%" className="align-L" rowSpan={2}>Sports</th>
                                <th width='8.1%' className="align-L" rowSpan={2}>Market Date</th>
                                <th className="align-L" rowSpan={2}>Event/Market Name</th>
                                <th width="21%" className="align-C border-l bg-yellow" colSpan={3}>Player P/L</th>
                                <th width="6%" className="align-C border-l" rowSpan={2}>Downline P/L</th>
                            </tr>
                            <tr>
                                <th width="7%" className="border-l bg-yellow" style={{ textAlign: 'center' }}>1</th>
                                <th width="7%" className="bg-yellow" style={{ textAlign: 'center' }}>X</th>
                                <th width="7%" className="bg-yellow" style={{ textAlign: 'center' }}>2</th>
                            </tr>
                        </tbody>



                        {cricketList.map((item, index) => {

                            return (
                                <tbody key={index} id="content_MATCH_ODDS_DRAW">
                                    <tr id="tempTr_MATCH_ODDS_DRAW" className="border-t">
                                        <td className="align-L" rowSpan={2} style={{ padding: '8px 10px' }} id="0_1">
                                            <a id="eventType" >Cricket</a></td>
                                        <td className="align-L border-l" rowSpan={2} id="1_1" style={{ padding: '8px 10px' }}>{item.date}</td>
                                        <td className="align-L border-l" style={{ padding: '8px 10px' }} id="linerh">

                                            <a onClick={() => { MarketClickOpen(index); seteventId(item.eventId) }} className={`${marketClick === index ? "btn open-odds" : "btn close-odds"}`} style={{}} name="oddsBtn_31135408">Open</a>

                                            <a id="marketPath">
                                                <strong id="eventName">{item.eventName}</strong>

                                            </a>
                                        </td>
                                        <td class="border-l" style={{ textAlign: 'center' }}><a className={`${item.teamA_total >= 0 ? "green" : "red"}`} id="selection_exposure_1">{item.teamA_total >= 0 ? parseFloat(item.teamA_total).toFixed(2) : '(' + parseFloat(Math.abs(item.teamA_total)).toFixed(2) + ')'}</a></td>
                                        <td style={{ textAlign: 'center' }}><a className={`${item.draw_total >= 0 ? "green" : "red"}`} id="selection_exposure_3">{item.draw_total >= 0 ? parseFloat(item.draw_total).toFixed(2) : '(' + parseFloat(Math.abs(item.draw_total)).toFixed(2) + ')'}</a></td>
                                        <td style={{ textAlign: 'center' }}><a id="selection_exposure_2"><span className={`${item.teamB_total >= 0 ? "green" : "red"}`}>{item.teamB_total >= 0 ? parseFloat(item.teamB_total).toFixed(2) : '(' + parseFloat(Math.abs(item.teamB_total)).toFixed(2) + ')'}</span></a></td>
                                        <td className="border-l">

                                            <a onClick={() => { setshowDownline(true); setpopup(1); seteventIdset(item.eventId); setmarketIdnew(item.marketId); setmarketName(item.eventName) }} className="btn" id="view">View</a></td>
                                    </tr>
                                    <tr id="expand_31135408" className="expanded" style={{ display: 'table-row' }}>
                                        <td className="border-l align-L" colSpan={4}>

                                            {/* <img className="expand-arrow" src={Transparent} /> */}
                                            {marketClick === index &&
                                                <CricketMatchSock setfancyName={setfancyName} setfancySelection={setfancySelection} setshowDownline={setshowDownline} setpopup={setpopup} marketpnl1={marketpnl1} marketpnl2={marketpnl2} marketpnl3={marketpnl3} popup={popup} isLoggedIn={props.isLoggedIn} tabMenu={props.tabMenu} changeDownlineLive={changeDownlineLive} showDownline={showDownline} eventId={eventId} />
                                            }
                                        </td>
                                        <td width={80} className="border-l" />
                                    </tr>
                                </tbody>
                            )
                        })}
                    </table>

                </div>

                <div className="match-wrap1">
                    <div className="total_all">
                        <h2>Soccer</h2>
                        <h2><img className="png-match" src={Soccerpng} /></h2>

                        <a className="btn_replay" onClick={() => { setreload(!reload); }} id="refresh_Match_Odds">
                            <img src={Transparent} /></a>

                        <a className="btn_replay" id="downloadFile_Sportsbook" style={{ display: 'none', width: '70px' }}>Download</a>
                    </div>
                    <table className="table011 risk_matchodd">
                        <tbody>
                            <tr>
                                <th width="10%" className="align-L" rowSpan={2}>Sports</th>
                                <th width='8.1%' className="align-L" rowSpan={2}>Market Date</th>
                                <th className="align-L" rowSpan={2}>Event/Market Name</th>
                                <th width="21%" className="align-C border-l bg-yellow" colSpan={3}>Player P/L</th>
                                <th width="6%" className="align-C border-l" rowSpan={2}>Downline P/L</th>
                            </tr>
                            <tr>
                                <th width="7%" className="border-l bg-yellow" style={{ textAlign: 'center' }}>1</th>
                                <th width="7%" className="bg-yellow" style={{ textAlign: 'center' }}>X</th>
                                <th width="7%" className="bg-yellow" style={{ textAlign: 'center' }}>2</th>
                            </tr>
                        </tbody>


                        {soccerList.map((item, index) => {
                            return (
                                <tbody key={index} id="content_MATCH_ODDS_DRAW">
                                    <tr id="tempTr_MATCH_ODDS_DRAW" className="border-t">
                                        <td className="align-L" rowSpan={2} style={{ padding: '8px 10px' }} id="0_1">
                                            <a id="eventType" >Soccer</a></td>
                                        <td className="align-L border-l" rowSpan={2} id="1_1" style={{ padding: '8px 10px' }}>{item.date}</td>
                                        <td className="align-L border-l" style={{ padding: '8px 10px' }} id="">

                                            <a onClick={() => { MarketClickOpen1(index); seteventId(item.eventId) }} className={`${marketClick1 === index ? "btn close-odds" : "btn open-odds"}`} style={{}} name="oddsBtn_31135408">Open</a>

                                            <a id="marketPath">
                                                <strong id="eventName">{item.eventName}</strong>

                                            </a>
                                        </td>
                                        <td class="border-l" style={{ textAlign: 'center' }}><a className={`${item.teamA_total >= 0 ? "green" : "red"}`} id="selection_exposure_1">{item.teamA_total >= 0 ? parseFloat(item.teamA_total).toFixed(2) : '(' + parseFloat(Math.abs(item.teamA_total)).toFixed(2) + ')'}</a></td>
                                        <td style={{ textAlign: 'center' }}><a className={`${item.draw_total >= 0 ? "green" : "red"}`} id="selection_exposure_3">{item.draw_total >= 0 ? parseFloat(item.draw_total).toFixed(2) : '(' + parseFloat(Math.abs(item.draw_total)).toFixed(2) + ')'}</a></td>
                                        <td style={{ textAlign: 'center' }}> <a id="selection_exposure_2"><span className={`${item.teamB_total >= 0 ? "green" : "red"}`}>{item.teamB_total >= 0 ? parseFloat(item.teamB_total).toFixed(2) : '(' + parseFloat(Math.abs(item.teamB_total)).toFixed(2) + ')'}</span></a></td>
                                        <td className="border-l">

                                            <a onClick={() => { setshowDownline(true); setpopup(1); seteventIdset(item.eventId); setmarketIdnew(item.marketId); setmarketName(item.eventName) }} className="btn" id="view">View</a></td>
                                    </tr>
                                    <tr id="expand_31135408" className="expanded" style={{ display: 'table-row' }}>
                                        <td className="border-l align-L" colSpan={4}>

                                            {/* <img className="expand-arrow" src={Transparent} /> */}


                                            {marketClick1 === index &&


                                                <SoccerMatchSock popup={popup} eventId={eventId} changeDownlineLive={changeDownlineLive} showDownline={showDownline} />

                                            }
                                        </td>
                                        <td width={80} className="border-l" />
                                    </tr>
                                </tbody>

                            )
                        })}

                    </table>
                </div>



                <div className="match-wrap1">
                    <div className="total_all">
                        <h2> Tennis</h2>
                        <h2><img className="png-match" src={Tennispng} /></h2>

                        <a className="btn_replay" onClick={() => { setreload(!reload); }} id="refresh_Match_Odds">
                            <img src={Transparent} /></a>

                        <a className="btn_replay" id="downloadFile_Sportsbook" style={{ display: 'none', width: '70px' }}>Download</a>
                    </div>

                    <table className="table011 risk_matchodd">

                        <tbody>
                            <tr>
                                <th width="10%" className="align-L" rowSpan={2}>Sports</th>
                                <th width="7%" className="align-L" rowSpan={2}>Market Date</th>
                                <th className="align-L" rowSpan={2}>Event/Market Name</th>
                                <th width="21%" className="align-C border-l bg-yellow" colSpan={3}>Player P/L</th>
                                <th width="6%" className="align-C border-l" rowSpan={2}>Downline P/L</th>
                            </tr>
                            <tr>
                                <th width="7%" className="border-l bg-yellow" style={{ textAlign: 'center' }}></th>
                                <th width="7%" className="bg-yellow" style={{ textAlign: 'center' }}>1</th>
                                <th width="7%" className="bg-yellow" style={{ textAlign: 'center' }}>2</th>
                            </tr>
                        </tbody>

                        {tennisList.map((item, index) => {

                            return (
                                <tbody id="content_MATCH_ODDS_DRAW">
                                    <tr id="tempTr_MATCH_ODDS_DRAW" className="border-t">
                                        <td className="align-L" rowSpan={2} style={{ padding: '8px 10px' }} id="0_1">
                                            <a id="eventType" >Tennis</a></td>
                                        <td className="align-L border-l" rowSpan={2} id="1_1" style={{ padding: '8px 10px' }}>{item.date}</td>
                                        <td className="align-L border-l" style={{ padding: '8px 10px' }} id="">

                                            <a onClick={() => { MarketClickOpen2(index); seteventId(item.eventId) }} className={`${marketClick2 === index ? "btn close-odds" : "btn open-odds"}`} style={{}} name="oddsBtn_31135408">Open</a>

                                            <a id="marketPath">
                                                <strong id="eventName">{item.eventName}</strong>

                                            </a>
                                        </td>
                                        <td className="border-l" style={{ padding: '8px 10px' }}>
                                            <a className style={{ textAlign: 'center' }} id="selection_exposure_1">
                                                <span className="red"></span></a></td>
                                        <td style={{ textAlign: 'center' }}><a className={`${item.teamA_total >= 0 ? "green" : "red"}`} id="selection_exposure_1">{item.teamA_total >= 0 ? parseFloat(item.teamA_total).toFixed(2) : '(' + parseFloat(Math.abs(item.teamA_total)).toFixed(2) + ')'}</a></td>
                                        <td style={{ textAlign: 'center' }}><a style={{ textAlign: 'center' }} id="selection_exposure_2"><span className={`${item.teamB_total >= 0 ? "green" : "red"}`}>{item.teamB_total >= 0 ? parseFloat(item.teamB_total).toFixed(2) : '(' + parseFloat(Math.abs(item.teamB_total)).toFixed(2) + ')'}</span></a></td>
                                        <td className="border-l">

                                            <a onClick={() => { setshowDownline(true); setpopup(1); seteventIdset(item.eventId); setmarketIdnew(item.marketId); setmarketName(item.eventName) }} className="btn" id="view">View</a></td>
                                    </tr>
                                    <tr id="expand_31135408" className="expanded" style={{ display: 'table-row' }}>
                                        <td className="border-l align-L" colSpan={3}>

                                            {marketClick2 === index &&

                                                <TennisMatchSock popup={popup} changeDownlineLive={changeDownlineLive} showDownline={showDownline} eventId={eventId} />

                                            }
                                        </td>

                                        <td width={80} className="border-l" />
                                    </tr>
                                </tbody>
                            )
                        })}
                    </table>
                </div>

                {/* <div className="equalwidth">
                    <div className="match-wrap">
                        <div className="total_all">
                            <h2>Sports Book</h2>

                            <a className="btn_replay" id="refresh_Ow"><img src={Transparent} /></a>

                            <a className="btn_replay" id="downloadFile_Sportsbook" style={{ display: 'none', width: '70px' }}>Download</a>
                        </div>
                        <table style={{ display: 'none' }}>
                            <tbody>
                                <tr id="tempTr_Ow">
                                    <td className="align-L" rowSpan={1} style={{}}>
                                        <a id="eventType" /></td>
                                    <td className="align-L border-l" rowSpan={1} id="marketTime" style={{}} />
                                    <td className="align-L border-l">

                                        <a id="marketPath">
                                            <strong id="eventName" />

                                            <img className="fromto" src={Transparent} />
                                            <span id="marketName" />
                                        </a>
                                    </td>
                                    <td className="border-l" id="amount" />
                                </tr>
                                <tr id="tempTr_noData_Ow">
                                    <td className="no-data" colSpan={4}>
                                        <p>No Data
                                        </p>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <table className="table01">
                            <tbody>
                                <tr>
                                    <th width="10%" className="align-L">Sports</th>
                                    <th width="8%" className="align-L">Market Date</th>
                                    <th className="align-L">Event/Market Name</th>
                                    <th width="26%" className>Matched Amount</th>
                                </tr>
                            </tbody>
                            <tbody id="content_Ow">
                                <tr id="tempTr_noData_Ow">
                                    <td className="no-data" colSpan={4}>
                                        <p>No Data
                                        </p>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="match-wrap">
                        <div className="total_all">
                            <h2>Premium </h2>

                            <a className="btn_replay" id="refresh_Sportradar"><img src={Transparent} /></a>

                            <a className="btn_replay" id="downloadFile_Sportradar" style={{ display: 'none', width: '70px' }}>Download</a>
                        </div>
                        <table style={{ display: 'none' }}>
                            <tbody>
                                <tr id="tempTr_Sportradar">
                                    <td className="align-L" rowSpan={1} style={{}}>
                                        <a id="eventType" /></td>
                                    <td className="align-L border-l" rowSpan={1} id="marketTime" style={{}} />
                                    <td className="align-L border-l">

                                        <a id="marketPath">
                                            <strong id="eventName" />

                                            <img className="fromto" src={Transparent} />
                                            <span id="marketName" />
                                        </a>
                                    </td>
                                    <td className="border-l" id="amount" />
                                </tr>
                                <tr id="tempTr_noData_Sportradar">
                                    <td className="no-data" colSpan={4}>
                                        <p>No Data
                                        </p>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <table className="table01">
                            <tbody>
                                <tr>
                                    <th width="10%" className="align-L">Sports</th>
                                    <th width="8%" className="align-L">Market Date</th>
                                    <th className="align-L">Event/Market Name</th>
                                    <th width="26%" className>Matched Amount</th>
                                </tr>
                            </tbody>
                            <tbody id="content_Sportradar">
                                <tr id="tempTr_noData_Sportradar">
                                    <td className="no-data" colSpan={4}>
                                        <p>No Data
                                        </p>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="match-wrap">
                        <div className="total_all">
                            <h2>Binary</h2>

                            <a className="btn_replay" id="refresh_Binary"><img src={Transparent} /></a>

                            <a className="btn_replay" id="downloadFile_Binary" style={{ display: 'none', width: '70px' }}>Download</a>
                        </div>
                        <table style={{ display: 'none' }}>
                            <tbody>
                                <tr id="tempTr_TS_BINARY">
                                    <td className="align-L" rowSpan={1} style={{}}>
                                        <a id="eventType" /></td>
                                    <td className="align-L border-l" rowSpan={1} id="marketTime" style={{}} />
                                    <td className="align-L border-l">

                                        <a className="btn open-odds" id="showOddsBtn" style={{}}>Open</a>

                                        <a id="marketPath">
                                            <strong id="eventName" />

                                            <img className="fromto" src={Transparent} />
                                            <span id="marketName" />
                                        </a>
                                    </td>
                                    <td className="border-l">
                                        <a className id="min_exposure">-</a></td>
                                    <td>
                                        <a className id="max_exposure">-</a></td>
                                    <td className="border-l">
                                        <a className="btn-book" id="books">Books</a></td>
                                </tr>
                                <tr id="tempTr_expand_TS_BINARY" className="expand" style={{ display: 'none' }}>
                                    <td className="border-l align-L" colSpan={3}>

                                        <img className="expand-arrow" src={Transparent} />
                                        <iframe src frameBorder={0} height={197} scrolling="no" />

                                    </td>
                                    <td width={80} className="border-l" />
                                </tr>
                                <tr id="tempTr_noData_TS_BINARY">
                                    <td className="no-data" colSpan={6}>
                                        <p>No Data
                                        </p>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <table className="table01 risk_matchodd">
                            <tbody>
                                <tr>
                                    <th width="10%" className="align-L" rowSpan={2}>Sports</th>
                                    <th width="8%" className="align-L" rowSpan={2}>Market Date</th>
                                    <th className="align-L" rowSpan={2}>Event/Market Name</th>
                                    <th width="18%" className="align-C border-l bg-yellow" colSpan={2}>Player P/L</th>
                                    <th width="6%" className="align-C border-l" rowSpan={2}>Books</th>
                                </tr>
                                <tr>

                                </tr>
                            </tbody>
                            <tbody id="content_TS_BINARY">
                                <tr id="tempTr_noData_TS_BINARY">
                                    <td className="no-data" colSpan={6}>
                                        <p>No Data
                                        </p>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                    </div>
                    <div className="match-wrap">
                        <div className="total_all">
                            <h2>Other Markets</h2>

                            <a className="btn_replay" id="refresh_Other_Market"><img src={Transparent} /></a>

                            <a className="btn_replay" id="downloadFile_Other_Market" style={{ display: 'none', width: '70px' }}>Download</a>
                        </div>
                        <table style={{ display: 'none' }}>
                            <tbody>
                                <tr id="tempTr_OTHER_MARKET">
                                    <td className="align-L" rowSpan={1} style={{}}>
                                        <a id="eventType" /></td>
                                    <td className="align-L border-l" rowSpan={1} id="marketTime" style={{}} />
                                    <td className="align-L border-l">

                                        <a id="marketPath">
                                            <strong id="eventName" />

                                            <img className="fromto" src={Transparent} />
                                            <span id="marketName" />
                                        </a>
                                    </td>
                                    <td className="border-l" id="amount" />
                                </tr>
                                <tr id="tempTr_noData_OTHER_MARKET">
                                    <td className="no-data" colSpan={4}>
                                        <p>No Data
                                        </p>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <table className="table01">
                            <tbody>
                                <tr>
                                    <th width="10%" className="align-L">Sports</th>
                                    <th width="8%" className="align-L">Market Date</th>
                                    <th className="align-L">Event/Market Name</th>
                                    <th width="26%" className>Matched Amount</th>
                                </tr>
                            </tbody>
                            <tbody id="content_OTHER_MARKET">
                                <tr id="tempTr_noData_OTHER_MARKET">
                                    <td className="no-data" colSpan={4}>
                                        <p>No Data
                                        </p>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                    </div>
                </div>
            */}
            </div>

            {showDownline === true && popup === 1 && <MarketView changeDownlineLive={changeDownlineLive} eventId={eventIdset} marketId={marketIdnew} tie={marketData.runnerId3} marketname={marketName + ' - Match Odds'} />}
            {showDownline === true && popup === 2 && <MarketView changeDownlineLive={changeDownlineLive} eventId={eventIdset} marketId={marketIdnew} tie={bookData2.runnerId3} marketname={bookData2.eventName + ' - BookMaker'} />}
            {showDownline === true && popup === 3 && <DeclaredFancy changeDownlineLive={changeDownlineLive} eventId={eventIdset} marketname={marketData.marketName ? marketData.eventName + ' - Declared Fancy' : bookData2.eventName + ' - Declared Fancy'} />}

            {showDownline === true && popup === 4 && <FancyBook setfancySelection={setfancySelection} setshowDownline={setshowDownline} setpopup={setpopup} setfancyName={setfancyName} changeDownlineLive={changeDownlineLive} eventId={eventId} selectionId={fancySelection} marketname={marketData.marketName ? fancyName : fancyName} />}
        </React.Fragment>
    )
}
